import { CategoryKey } from '@/views/PressKit/data/categories';

export type Content = {
  title: { [key: string]: string };
  fileUrl: string;
  thumbnailUrl?: string;
};

export const mediaGallery: Content[] = [
  {
    title: { 'pt-BR': 'Maps em tablet na horizontal', 'en-US': 'Maps on tablet in horizontal' },
    fileUrl: '/press-kit/media-gallery/1x1/Maps em tablet na horizontal.png',
  },
  {
    title: { 'pt-BR': 'Maps em tablet na vertical', 'en-US': 'Maps on tablet in vertical' },
    fileUrl: '/press-kit/media-gallery/1x1/Maps em tablet na vertical.png',
  },
  {
    title: {
      'pt-BR': 'Página inicial com banner de enoturismo',
      'en-US': 'Homepage with wine tourism banner',
    },
    fileUrl: '/press-kit/media-gallery/1x1/Página inicial com banner de enoturismo.png',
  },
  {
    title: {
      'pt-BR': 'Página inicial com banner de geolocalização',
      'en-US': 'Homepage with geolocation banner',
    },
    fileUrl: '/press-kit/media-gallery/1x1/Página inicial com banner de geolocalização.png',
  },
  {
    title: {
      'pt-BR': 'Página inicial no tablet',
      'en-US': 'Homepage on tablet',
    },
    fileUrl: '/press-kit/media-gallery/1x1/Página inicial no tablet.png',
  },
  {
    title: {
      'pt-BR': 'Página inicial',
      'en-US': 'Homepage',
    },
    fileUrl: '/press-kit/media-gallery/1x1/Página inicial.png',
  },
  {
    title: {
      'pt-BR': 'Versão em tablet',
      'en-US': 'Tablet version',
    },
    fileUrl: '/press-kit/media-gallery/1x1/Versão em tablet.png',
  },
  {
    title: {
      'pt-BR': 'Calendário de eventos',
      'en-US': 'Events calendar',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Calendário de eventos.png',
  },
  {
    title: {
      'pt-BR': 'Calendário de eventos',
      'en-US': 'Events calendar',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Calendário de eventos (2).png',
  },
  {
    title: {
      'pt-BR': 'Calendário de eventos',
      'en-US': 'Events calendar',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Calendário de eventos (3).png',
  },
  {
    title: {
      'pt-BR': 'Confraria',
      'en-US': 'Confraternity',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Confraria.png',
  },
  {
    title: {
      'pt-BR': 'Diferentes portais de conteúdos',
      'en-US': 'Different content portals',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Diferentes portais de conteúdos.png',
  },
  {
    title: {
      'pt-BR': 'Diferentes portais de conteúdos',
      'en-US': 'Different content portals',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Diferentes portais de conteúdos (2).png',
  },
  {
    title: {
      'pt-BR': 'Experiência no tablet - mapa na horizontal',
      'en-US': 'Tablet experience - map in horizontal',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Experiência no tablet - mapa na horizontal.png',
  },
  {
    title: {
      'pt-BR': 'Experiência no tablet - mapa na vertical',
      'en-US': 'Tablet experience - map in vertical',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Experiência no tablet - mapa na vertical.png',
  },
  {
    title: {
      'pt-BR': 'Experiência no tablet',
      'en-US': 'Tablet experience',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Experiência no tablet.png',
  },
  {
    title: {
      'pt-BR': 'Experiência no tablet',
      'en-US': 'Tablet experience',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Experiência no tablet (2).png',
  },
  {
    title: {
      'pt-BR': 'Ficha de Degustação',
      'en-US': 'Tasting sheet',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Ficha de Degustação.png',
  },
  {
    title: {
      'pt-BR': 'Página inicial com diferentes banners',
      'en-US': 'Homepage with different banners',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Página inicial com diferentes banners.png',
  },
  {
    title: {
      'pt-BR': 'Portais',
      'en-US': 'Portals',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Portais.png',
  },
  {
    title: {
      'pt-BR': 'Portal Confraria',
      'en-US': 'Confraternity portal',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Portal Confraria.png',
  },
  {
    title: {
      'pt-BR': 'Portal regiões com um mapa e experiência no tablet',
      'en-US': 'Regions portal with a map and tablet experience',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Portal regiões com um mapa e experiência no tablet.png',
  },
  {
    title: {
      'pt-BR': 'Portal regiões',
      'en-US': 'Regions portal',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Portal regiões.png',
  },
  {
    title: {
      'pt-BR': 'Serviço de geolocalização',
      'en-US': 'Geolocation service',
    },
    fileUrl: '/press-kit/media-gallery/16x9/Serviço de geolocalização.png',
  },
];

export const videoLibrary: Content[] = [
  {
    title: {
      'pt-BR': 'Homepage como navegar pelo App',
      'en-US': 'Homepage how to navigate',
    },
    fileUrl: 'https://streamable.com/dpezpj',
    thumbnailUrl: '/press-kit/video-library/01 HOME COMO NAVEGAR PELO APP.png',
  },
  {
    title: {
      'pt-BR': 'Ficha de Degustação',
      'en-US': 'Tasting sheet',
    },
    fileUrl: 'https://streamable.com/g2uh29',
    thumbnailUrl: '/press-kit/video-library/01.1 FICHA DE DEGUSTAÇÃO.png',
  },
  {
    title: {
      'pt-BR': 'Portal Uvas',
      'en-US': 'Grapes portal',
    },
    fileUrl: 'https://streamable.com/gdz01c',
    thumbnailUrl: '/press-kit/video-library/02 PORTAL UVAS.png',
  },
  {
    title: {
      'pt-BR': 'Portal Vitivinicultura',
      'en-US': 'Wine production portal',
    },
    fileUrl: 'https://streamable.com/hti09e',
    thumbnailUrl: '/press-kit/video-library/03 PORTAL VITIVINICULTURA.png',
  },
  {
    title: {
      'pt-BR': 'Portal Regiões',
      'en-US': 'Regions portal',
    },
    fileUrl: 'https://streamable.com/4jzt0n',
    thumbnailUrl: '/press-kit/video-library/04 PORTAL REGIÕES.png',
  },
  {
    title: {
      'pt-BR': 'Portal Degustação',
      'en-US': 'Tasting portal',
    },
    fileUrl: 'https://streamable.com/lp1y41',
    thumbnailUrl: '/press-kit/video-library/05 PORTAL DEGUSTAÇÃO.png',
  },
  {
    title: {
      'pt-BR': 'Portal Serviço',
      'en-US': 'Service portal',
    },
    fileUrl: 'https://streamable.com/pvl1b8',
    thumbnailUrl: '/press-kit/video-library/06 PORTAL SERVIÇO.png',
  },
  {
    title: {
      'pt-BR': 'Portal Harmonização',
      'en-US': 'Harmonization portal',
    },
    fileUrl: 'https://streamable.com/5azs1d',
    thumbnailUrl: '/press-kit/video-library/07 PORTAL HARMONIZAÇÃO.png',
  },
  {
    title: {
      'pt-BR': 'Portal Enoturismo',
      'en-US': 'Wine tourism portal',
    },
    fileUrl: 'https://streamable.com/20ybny',
    thumbnailUrl: '/press-kit/video-library/08 PORTAL ENOTURISMO.png',
  },
  {
    title: {
      'pt-BR': 'Portal Enogastronomia',
      'en-US': 'Gastronomy portal',
    },
    fileUrl: 'https://streamable.com/eejz37',
    thumbnailUrl: '/press-kit/video-library/09 PORTAL ENOGASTRONOMIA.png',
  },
  {
    title: {
      'pt-BR': 'Portal Vinocultura',
      'en-US': 'Viniculture portal',
    },
    fileUrl: 'https://streamable.com/xbttaa',
    thumbnailUrl: '/press-kit/video-library/010 PORTAL VINOCULTURA.png',
  },
  {
    title: {
      'pt-BR': 'Portal Confraria',
      'en-US': 'Confraternity portal',
    },
    fileUrl: 'https://streamable.com/qx9ayj',
    thumbnailUrl: '/press-kit/video-library/011 PORTAL CONFRARIA.png',
  },
  {
    title: {
      'pt-BR': 'Eventos na Confraria',
      'en-US': 'Events in the Confraternity',
    },
    fileUrl: 'https://streamable.com/0mvxa4',
    thumbnailUrl: '/press-kit/video-library/011.2 EVENTOS NA CONFRARIA.png',
  },
  {
    title: {
      'pt-BR': 'Prime Wine',
      'en-US': 'Prime Wine',
    },
    fileUrl: 'https://streamable.com/snheqa',
    thumbnailUrl: '/press-kit/video-library/012 BLOG E NOTÍCIAS.png',
  },
  {
    title: {
      'pt-BR': 'Canal',
      'en-US': 'Channel',
    },
    fileUrl: 'https://streamable.com/a50js4',
    thumbnailUrl: '/press-kit/video-library/013 CANAL.png',
  },
  {
    title: {
      'pt-BR': 'Serviço de Geolocalização',
      'en-US': 'Geolocation service',
    },
    fileUrl: 'https://streamable.com/5uk8nc',
    thumbnailUrl: '/press-kit/video-library/014 SERVIÇO DE GEOLOCALIZAÇÃO.png',
  },
  {
    title: {
      'pt-BR': 'Busca no App',
      'en-US': 'App search',
    },
    fileUrl: 'https://streamable.com/m15db5',
    thumbnailUrl: '/press-kit/video-library/015 BUSCA NO APP.png',
  },
  {
    title: {
      'pt-BR': 'Calendário de eventos',
      'en-US': 'Events calendar',
    },
    fileUrl: 'https://streamable.com/oboe9i',
    thumbnailUrl: '/press-kit/video-library/016 CALENDÁRIO DE EVENTOS.png',
  },
  {
    title: {
      'pt-BR': 'Perfil do usuário',
      'en-US': 'User profile',
    },
    fileUrl: 'https://streamable.com/hhw6y1',
    thumbnailUrl: '/press-kit/video-library/017 PERFIL DO USUÁRIO.png',
  },
];

export const ourLogos: Content[] = [
  {
    title: {
      'pt-BR': 'Logos',
      'en-US': 'Logos',
    },
    fileUrl: '/press-kit/our-logos/Logos - Enoteca Mundi.zip',
  },
  {
    title: {
      'pt-BR': 'Ícones',
      'en-US': 'Icons',
    },
    fileUrl: '/press-kit/our-logos/Ícones - Enoteca Mundi.zip',
  },
];

export const team: Content[] = [
  {
    title: {},
    fileUrl: '/press-kit/team/01.jpg',
  },
  {
    title: {},
    fileUrl: '/press-kit/team/02.jpg',
  },
  {
    title: {},
    fileUrl: '/press-kit/team/03.jpg',
  },
  {
    title: {},
    fileUrl: '/press-kit/team/04.jpg',
  },
  {
    title: {},
    fileUrl: '/press-kit/team/05.jpg',
  },
  {
    title: {},
    fileUrl: '/press-kit/team/06.jpg',
  },
];

export const pressReleases: Content[] = [
  {
    title: {
      'pt-BR': 'Press Release - português',
      'en-US': 'Press Release - portuguese',
    },
    fileUrl: '/press-kit/press-releases/Press Release - português.pdf',
  },
  {
    title: {
      'pt-BR': 'Press Release - inglês',
      'en-US': 'Press Release - english',
    },
    fileUrl: '/press-kit/press-releases/Press Release - english.pdf',
  },
];

const PressKitContents = {
  [CategoryKey.MediaGallery]: mediaGallery,
  [CategoryKey.VideoLibrary]: videoLibrary,
  [CategoryKey.OurLogos]: ourLogos,
  [CategoryKey.Team]: team,
  [CategoryKey.PressReleases]: pressReleases,
};

export default PressKitContents;
